import { ArrowDownUp } from 'lucide-react'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ShopReorderContext } from '~/components/ShopReorder'
import { IconButton, Tooltip } from '~/ui'

interface ReorderButtonProps {
  activeTab: 'products' | 'collections'
}

export const ReorderButton = ({ activeTab }: ReorderButtonProps) => {
  const { t } = useTranslation()
  const context = useContext(ShopReorderContext)

  if (!context) {
    console.error('ShopReorderContext not found')
    return null
  }

  const { setOpen } = context

  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <IconButton
          variant="ghost"
          onClick={() => setOpen(activeTab)}
          aria-label={t('page.products.top_navigation.reorder')}
        >
          <ArrowDownUp />
        </IconButton>
      </Tooltip.Trigger>
      <Tooltip.Content>
        {t('page.products.top_navigation.reorder')}
      </Tooltip.Content>
    </Tooltip>
  )
}
